// extracted by mini-css-extract-plugin
module.exports = {"row":"ResourcesSection_row__uosal","mainRow":"ResourcesSection_mainRow__wXRmL","wrapper":"ResourcesSection_wrapper__h30BR","title":"ResourcesSection_title__zeZ_1"};